import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "./contexts/AuthContext";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { Toaster } from "./components/ui/sonner";

import Home from "./pages/Home";
import Categories from "./pages/Categories";
import CategoryDetail from "./pages/CategoryDetail";
import SearchPage from "./pages/SearchPage";
import BusinessDetail from "./pages/BusinessDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ListBusiness from "./pages/ListBusiness";
import Dashboard from "./pages/Dashboard";
import Pricing from "./pages/Pricing";
import Admin from "./pages/Admin";
import VerifyEmail from "./pages/VerifyEmail";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import StaticPage from "./pages/StaticPage";
import VerifyBanner from "./components/VerifyBanner";
import HeadScripts from "./components/HeadScripts";
import AuthCallback from "./pages/AuthCallback";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

function App() {
  return (
    <div className="App min-h-screen bg-white text-zinc-900">
      <BrowserRouter>
        <AuthProvider>
          <HeadScripts />
          <Navbar />
          <VerifyBanner />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/category/:slug" element={<CategoryDetail />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/business/:id" element={<BusinessDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/list-business" element={<ListBusiness />} />
              <Route path="/dashboard/*" element={<Dashboard />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/admin/*" element={<Admin />} />
              <Route path="/about" element={<StaticPage />} />
              <Route path="/contact" element={<StaticPage />} />
              <Route path="/terms" element={<StaticPage />} />
              <Route path="/privacy" element={<StaticPage />} />
              <Route path="/:slug" element={<StaticPage />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
